import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'pavemend_cookie_consent';

const useCookieConsent = () => {
  const [status, setStatus] = useState(null); // null | 'accepted' | 'declined'

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) setStatus(stored);
  }, []);

  const accept = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setStatus('accepted');
  }, []);

  const decline = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setStatus('declined');
  }, []);

  return { status, accept, decline };
};

export default useCookieConsent;
